var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"751d3f0bf1ad4beb97e05fb59ec8348f24c815fe"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["symbola@vested-bw"]={id:"751d3f0bf1ad4beb97e05fb59ec8348f24c815fe"};
      